module.exports = __webpack_public_path__ + "static/media/HB-LogoNew-NoPayoff.feecfbbb.png";